import $ from 'jquery'

const DARK = 'dark'
const LIGHT = 'light'

const DARK_MODE_CLASS = 'dark-mode'
const LIGHT_MODE_CLASS = 'light-mode'

const HTML_DARK_CLASS = 'dark'

const USER_DATA_SELECTOR = '#current-user-data'
const USER_DATA_COLOR_THEME = 'colorTheme'

/**
 * Detects color theme
 * @returns {string}
 */
export function detectTheme() {
  const $body = $('body')
  if ($body.hasClass(DARK_MODE_CLASS)) return DARK;
  if ($body.hasClass(LIGHT_MODE_CLASS)) return LIGHT;

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? DARK : LIGHT
}

/**
 * Applies CSS changes for selected theme
 * @param {string} theme
 */
export function setTheme(theme) {
  const $body = $('body')
  const $html = $('html')

  if (theme === DARK) {
    $body.removeClass(LIGHT_MODE_CLASS).addClass(DARK_MODE_CLASS)
    $html.addClass(HTML_DARK_CLASS)
  } else {
    $body.removeClass(DARK_MODE_CLASS).addClass(LIGHT_MODE_CLASS)
    $html.removeClass(HTML_DARK_CLASS)
  }
}

/**
 * Returns color theme from user's profile
 * @returns {string|undefined}
 */
export function userColorTheme() {
  return $(USER_DATA_SELECTOR).data(USER_DATA_COLOR_THEME)
}

/**
 * Updates color theme in user's profile
 * @param {string} theme
 */
export function updateUserColorTheme(theme) {
  $(USER_DATA_SELECTOR).data(USER_DATA_COLOR_THEME, theme)

  SOPHIA.ajax({
    data: { color_theme: theme },
    dataType: 'json',
    method: 'POST',
    url: SOPHIA.Routes.update_color_theme_profile_path()
  })
}
